import './etapas.css';

export type Etapa<T extends string> = {
  chave: T;
  nome: string;
  /** Falso quando a etapa ainda não faz sentido — e aí o `motivo` é obrigatório. */
  ativa?: boolean;
  /** "Escolha uma conversa primeiro": aparece no `title`, como no botão. */
  motivo?: string;
};

export type EtapasProps<T extends string> = {
  abas: Etapa<T>[];
  atual: T;
  aoIr: (chave: T) => void;
  /** O que as etapas dividem, para o leitor de tela: "Partes do atendimento". */
  rotulo: string;
};

/**
 * As etapas de uma tela no celular (MOBILE.md §2, padrão "etapas").
 *
 * A tela tem duas ou três regiões que no desktop convivem; em 390px viram
 * abas fixas logo abaixo da barra da casca. Abas, e não botões de voltar: com
 * voltar, chegar à terceira região exige passar pela segunda, e o que
 * diferencia o produto precisa estar a um toque.
 *
 * O ☰ não entra aqui: ele é da barra da casca, e assim existe também nos
 * estados em que estas abas não fazem sentido (sem acesso, erro). Quem
 * renderiza decide QUANDO mostrar — só em tela estreita.
 */
export function Etapas<T extends string>({ abas, atual, aoIr, rotulo }: EtapasProps<T>) {
  return (
    <nav className="etapas" role="tablist" aria-label={rotulo}>
      {abas.map((aba) => {
        const ativa = aba.ativa !== false;
        return (
          <button
            key={aba.chave}
            type="button"
            role="tab"
            className="etapas__aba"
            aria-selected={atual === aba.chave}
            disabled={!ativa}
            title={ativa ? undefined : aba.motivo}
            onClick={() => aoIr(aba.chave)}
          >
            {aba.nome}
          </button>
        );
      })}
    </nav>
  );
}
